import { call, put, select, takeLatest } from 'redux-saga/effects';

import { getTranslationsData } from 'services/data-manager';
import getConsentsData, {
    ConsentOrderingResponseData,
} from 'services/data-manager/get-consents-data';
import { Params } from 'services/data-manager/get-translations-data';

import LANGUAGES_NAMES from 'utils/Language/languageNames';

import { selectLanguage } from '../user/selectors';
import {
    getLanguages,
    getLanguagesFailure,
    getLanguagesRequest,
    getLanguagesSuccess,
    setConsentOrdering,
} from './actions';
import { GET_CONSENT_ORDERING, GET_LANGUAGES } from './constants';

export function* onGetLanguages(action: ReturnType<typeof getLanguages>) {
    const { onRequestEnd } = action.meta || {};

    try {
        const { languages } = action.payload;

        if (languages) {
            yield put(getLanguagesRequest());

            const currentLanguage: keyof typeof LANGUAGES_NAMES = yield select(
                selectLanguage,
            );

            yield call<(params: Params) => Promise<void>>(getTranslationsData, {
                languages,
                currentLanguage,
            });
            yield put(getLanguagesSuccess());
        }
    } catch (error) {
        yield put(getLanguagesFailure(error));
    } finally {
        if (onRequestEnd) {
            yield call(onRequestEnd);
        }
    }
}

export function* onGetConsents() {
    try {
        const response: ConsentOrderingResponseData = yield call(
            getConsentsData,
        );

        yield put(
            setConsentOrdering({ consentOrdering: response.consent_ordering }),
        );
    } catch (error) {
        yield put(setConsentOrdering({ consentOrdering: undefined }));
    }
}

export default [
    takeLatest(GET_LANGUAGES, onGetLanguages),
    takeLatest(GET_CONSENT_ORDERING, onGetConsents),
];
